/* Fiyatlarda sadece '.00' kuruşlarını gizler: 990.00TL -> 990 TL. .99 gibi kuruşlara dokunmaz. */
(function () {
  var TEST = /\d\.00\s*TL/;
  var REPLACE = /(\d)\.00\s*TL/g;
  var SKIP = { SCRIPT: 1, STYLE: 1, TEXTAREA: 1, NOSCRIPT: 1 };

  function fixNode(node) {
    if (node.nodeType === 3) {
      if (TEST.test(node.nodeValue)) node.nodeValue = node.nodeValue.replace(REPLACE, '$1 TL');
      return;
    }
    if (node.nodeType !== 1 || SKIP[node.nodeName]) return;
    var walker = document.createTreeWalker(node, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        var p = n.parentNode && n.parentNode.nodeName;
        if (SKIP[p]) return NodeFilter.FILTER_REJECT;
        return TEST.test(n.nodeValue) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      }
    });
    var list = [];
    while (walker.nextNode()) list.push(walker.currentNode);
    for (var i = 0; i < list.length; i++) {
      list[i].nodeValue = list[i].nodeValue.replace(REPLACE, '$1 TL');
    }
  }

  function run() {
    fixNode(document.body);
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.type === 'characterData') {
          fixNode(m.target);
        } else {
          for (var j = 0; j < m.addedNodes.length; j++) fixNode(m.addedNodes[j]);
        }
      }
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.body) run();
  else document.addEventListener('DOMContentLoaded', run);
})();
